/**
 * TeamQuickWins — Quick Wins tab (Module 1)
 *
 * Premium leesbaar:
 * - Cijfer in marge (Playfair, groot) als visueel anker
 * - Source-label klein als eyebrow erboven
 * - Actie-zin in rustige body-tekst (16px Inter), niet display
 * - Witruimte tussen acties als ritme
 *
 * Ontwerp-principe: dit zijn werkacties om te scannen, niet citaten om te bewonderen.
 */

import React from 'react';
import { SPACING, TYPE, useIsMobile } from '../../ui/tokens';
import { useCopy } from '../../i18n/LanguageContext';

export default function TeamQuickWins({ insights }) {
    const isMobile = useIsMobile();
    const t = useCopy().teamPanels.quickWins;

    const rawItems = insights?.quickWins || [];

    const items = rawItems.map((item) => {
        if (typeof item === 'string') {
            return { source: 'reflectie', action: item };
        }
        return item;
    });

    if (items.length === 0) {
        return (
            <div style={{ padding: SPACING.lg, fontSize: 13, color: 'var(--tof-text-muted)' }}>
                {t.empty}
            </div>
        );
    }

    return (
        <div
            style={{
                display: 'grid',
                gap: isMobile ? SPACING.lg : SPACING.xl,
            }}
        >
            {/* Geen eigen kop meer: de paneelkop en de lead zeggen al wat dit
                is, en tegel, kop en eyebrow zeiden drie keer "voor morgen"
                (A5.6). countLabel en note staan nog in de copy. */}
            {/* Acties — leesbaar verticaal ritme */}
            <div
                style={{
                    display: 'grid',
                    gap: isMobile ? SPACING.md : SPACING.lg,
                }}
            >
                {items.map((item, index) => (
                    <ActionRow
                        key={index}
                        index={index + 1}
                        sourceLabel={t.sources[item.source] || t.sources.reflectie}
                        action={item.action}
                        isMobile={isMobile}
                    />
                ))}
            </div>
        </div>
    );
}

// =========================
// ACTION ROW
// =========================
// Cijfer in marge als anker. Eyebrow + actie-tekst rechts, leesbaar als artikel.

function ActionRow({ index, sourceLabel, action, isMobile }) {
    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '48px 1fr',
                gap: isMobile ? SPACING.xs : SPACING.lg,
                alignItems: 'start',
                paddingBottom: SPACING.md,
                borderBottom: '1px solid rgba(230, 221, 210, 0.5)',
            }}
        >
            {/* Cijfer in marge — Playfair, anker */}
            <div
                style={{
                    fontFamily: 'var(--tof-font-heading)',
                    fontSize: isMobile ? 20 : 28,
                    lineHeight: 1,
                    fontWeight: 500,
                    color: 'var(--tof-accent-sage-text)',
                    fontVariantNumeric: 'tabular-nums',
                    paddingTop: isMobile ? 0 : 4,
                }}
            >
                {String(index).padStart(2, '0')}
            </div>

            {/* Inhoud — eyebrow + leesbare actie-tekst */}
            <div style={{ display: 'grid', gap: SPACING.xs + 2 }}>
                <div
                    style={{
                        ...TYPE.eyebrow,
                        color: 'var(--tof-accent-sage-text)',
                    }}
                >
                    {sourceLabel}
                </div>
                <p
                    style={{
                        margin: 0,
                        fontFamily: 'var(--tof-font-body)',
                        fontSize: isMobile ? 15 : 16,
                        lineHeight: 1.6,
                        fontWeight: 400,
                        color: 'var(--tof-text)',
                        maxWidth: 720,
                    }}
                >
                    {action}
                </p>
            </div>
        </div>
    );
}
